module.exports = __webpack_public_path__ + "media/assets/partners/yourator-b828e791a7b9011023245205ce3551e3.svg";